

// useOrderDetails.js
import { useState, useEffect } from "react";
import axiosInstance from "../../../utils/axiosInstance";

function useCustomHook(status = "neworder") {
  const [orderData, setOrderData] = useState([]);
  const [products, setProducts] = useState([]);
  const [userDetails, setUserDetails] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      const orderResponse = await axiosInstance.get(
        `api/products/placeorder/pagination?status=${status}&page=${currentPage}`
      );

      if (orderResponse.status === 200) {
        const orders = orderResponse.data;
        setOrderData(orders.orders);
        setTotalPages(orders.totalPages);

        const productResponses = await Promise.all(
          orders.orders.map(async (order) =>
            Promise.all(
              order.product.map(async (product) => {
                const productResponse = await axiosInstance.get(
                  `/api/products/get-product/${product.productId}`
                );
                return productResponse.data; // Use data directly, as Axios parses the response
              })
            )
          )
        );
        setProducts(productResponses);

        const userResponses = await Promise.all(
          orders.orders.map(async (order) => {
            try {
              const userResponse = await axiosInstance.get(
                `/api/users/details/${order.user}`
              );

              if (userResponse.status === 200) {
                const userData = userResponse.data;
                return { userId: order.user, data: userData };
              } else {
                return { userId: order.user, data: null };
              }
            } catch (error) {
              console.error("Error fetching user details:", error);
              return { userId: order.user, data: null };
            }
          })
        );

        const userDetailsObject = userResponses.reduce((acc, user) => {
          acc[user.userId] = user.data;
          return acc;
        }, {});

        setUserDetails(userDetailsObject);
      } else {
        console.error("Error fetching orders. Status:", orderResponse.status);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, status]); // Include status as a dependency if needed

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  

  return {
    orderData,
    products,
    userDetails,
    currentPage,
    totalPages,
    handlePageChange,
    loading,
  };
}

export default useCustomHook;
